module.exports = __webpack_public_path__ + "img/dollar-empty.a61c4a04.svg";